import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import CreateIcon from '@material-ui/icons/Create';

import IconButton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/IconButton';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import { useBlueprintContext } from 'Context/BlueprintContext';

const styles = () => ({
  tooltip: {},
  root: {},
  icon: {},
});

const EditButton = ({
  className,
  classes,
  ...rest
}) => {
  const { isReadOnly } = useBlueprintContext();

  const render = () => {
    if (isReadOnly) {
      return <></>;
    }

    return (<IconButton
      data-edit-button
      classes={{
        tooltip: classes.tooltip,
        root: classNames(classes.root, className),
        icon: classes.icon,
      }}
      icon={CreateIcon}
      {...rest}
    />);
  };

  return render();
};
EditButton.defaultProps = {
  className: '',
};

EditButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(EditButton);
